import * as React from 'react';
import './loader.sass';

const Loader = () => (
  <div className='loader' data-testid='loader'>
    <img alt='tint' src='https://cdn.hypemarks.com/assets/splash5/Logo_Icon_warmRed_@2x.png' />
  </div>
);

export default Loader;
